export default {
    "kakuyomu.jp": { badge: "kakuyomu", name: "カクヨム" },
    "ncode.syosetu.com": { badge: "narou", name: "小説家になろう" },
    "novel18.syosetu.com": { badge: "novel18", name: "なろうR18" },
    "mid.syosetu.com": { badge: "midnight", name: "ミッドナイト" },
    "noc.syosetu.com": { badge: "nocturne", name: "ノクターン" },
    "mnlt.syosetu.com": { badge: "moonlight",  name: "ムーンライト" },
    "novelup.plus": { badge: "novelup", name: "ノベルアップ＋" },
    "estar.jp": { badge: "estar", name: "エブリスタ" },
    "www.alphapolis.co.jp": { badge: "alphapolis", name: "アルファポリス" },
    "novel.daysneo.com": { badge: "noveldays", name: "ノベルデイズ" },
    "novelism.jp": { badge: "novelism", name: "ノベリズム" },
    "sutekibungei.com": { badge: "suteki", name: "ステキブンゲイ" },
    "novema.jp": { badge: "novema", name: "ノベマ" },
    "www.novelabo.com": { badge: "novelabo", name: "ノベラボ" },
    "www.pixiv.net": { badge: "pixiv", name: "ピクシブ" },
    "r-nomad.com": { badge: "search", name: "恋愛遊牧民Ｒ+" },
    "compslink.jp": { badge: "search", name: "コンパスリンク" },
    "lony.jp": { badge: "search", name: "創作サイト総合サーチ Lony" },
    "www.dabun-doumei.com": { badge: "search", name: "駄文同盟.com" },
    "bungeiweb.net": { badge: "search", name: "文芸Webサーチ" },
}